import { Box } from '@vouched.id/vault';
import React from 'react';
import ReactJson from 'react-json-view';
import { copyHandler } from '../../utils';
import { Dropdown } from '../Dropdown';
import { getSelectedTemplateId } from 'utils/jobs';
export const DebugDropdowns = ({ jobDebugResults }) => {
    let parsedDebugResults;
    try {
        parsedDebugResults = jobDebugResults
            ? JSON.parse(jobDebugResults)
            : { results: 'No debug results available' };
    }
    catch {
        parsedDebugResults = { results: 'Unable to parse debug results' };
    }
    const templateId = getSelectedTemplateId(parsedDebugResults);
    return (React.createElement(Dropdown, { title: "Debug" },
        React.createElement(Box, null,
            templateId && (React.createElement(Box, { marginY: "spacing.default" },
                React.createElement("a", { className: "job-modal__debug__template-link", href: `/admin/templates/${templateId}`, rel: "noreferrer", target: "_blank" }, "Link to the template used for this ID"))),
            React.createElement("div", { "data-ph-mask": true },
                React.createElement(ReactJson, { enableClipboard: copyHandler, src: parsedDebugResults })))));
};
